import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import AfitdTypography from '../../common/elemental/AfitdTypography';

const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            paddingBottom: '4px',
        },
    }));
};

const DialogFieldLabel = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { children, ...otherProps } = props;

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <AfitdTypography variant="body2" clsLightBold={true} className={classes.root} {...otherProps}>
            {children}
        </AfitdTypography>
    );
};

export default DialogFieldLabel;
